/**
 *@desc 详情左侧
 *@author XinD
 *@date 2022/11/8
 */
import React, { Dispatch, FC, SetStateAction, useMemo } from "react";
import { observer } from "mobx-react-lite";
import styles from "../../index.module.scss";
import GiveTheThumbsUp from "@/pages/Gallery/components/GiveTheThumbsUp";
import { ImgAndPromptItemType } from "@/stores/gallery";
import Album, { AlbumData } from "@/pages/Gallery/components/Album";
import { useEventListener } from "ahooks";
import config from "@/config";
import { Divider } from "@chakra-ui/react";
interface LeftContentProps {
  resultPreviewList: ImgAndPromptItemType[];
  current?: ImgAndPromptItemType;
  metaJson: any;
  setCurrent: Dispatch<SetStateAction<ImgAndPromptItemType | undefined>>;
  onLike?: (image_id: number) => void;
  onCancelLike?: (image_id: number) => void;
  onAlbum?: (type: 1 | 2 | 3, albumData: AlbumData) => void;
  onError?: (e: any) => void;
}

const LeftContent: FC<LeftContentProps> = ({ ...props }) => {
  const {
    resultPreviewList,
    current,
    metaJson,
    setCurrent,
    onLike,
    onCancelLike,
    onAlbum,
    onError,
  } = props;
  const metaJsonThumbnailList = useMemo(() => {
    return (data: ImgAndPromptItemType) => {
      return data ? JSON.parse(data?.meta_json as string) : undefined;
    };
  }, []);
  // 左侧地步缩略图list
  const thumbnailListNode = useMemo(() => {
    return resultPreviewList?.map((item: ImgAndPromptItemType) => {
      return (
        <li
          key={item.image_id}
          onClick={() => {
            setCurrent(item);
          }}
          className={current?.image_id === item.image_id ? styles.active : ""}
        >
          <a
            href={`/arts/${item.image_id}`}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <img
              src={`${item.image_url}?x-oss-process=image/resize,w_52`}
              alt={metaJsonThumbnailList(item)?.data?.promptInfo?.original}
            />
          </a>
        </li>
      );
    });
  }, [resultPreviewList, current]);
  const previousAndNext = (type: number) => {
    if (type) {
      // 下一张
      const index = resultPreviewList.findIndex(
        (item: ImgAndPromptItemType) => item.image_id === current?.image_id,
      );
      if (index === resultPreviewList.length - 1) {
        setCurrent(resultPreviewList[0]);
      } else {
        setCurrent(resultPreviewList[index + 1]);
      }
    } else {
      // 上一张
      const index = resultPreviewList.findIndex(
        (item: ImgAndPromptItemType) => item.image_id === current?.image_id,
      );
      if (index === 0) {
        setCurrent(resultPreviewList[resultPreviewList.length - 1]);
      } else {
        setCurrent(resultPreviewList[index - 1]);
      }
    }
  };
  useEventListener("keydown", (e) => {
    if (e.keyCode === 39) {
      previousAndNext(1);
    }
    if (e.keyCode === 37) {
      previousAndNext(0);
    }
  });
  return (
    <div className={styles.leftWrapper}>
      <div className={styles.previewWrapper}>
        {resultPreviewList?.length > 1 && (
          <>
            <img
              src={`${config.buildCdnBaseUrl}assets/creator/left.png`}
              className={styles.left}
              onClick={() => {
                previousAndNext(0);
              }}
            />
            <img
              src={`${config.buildCdnBaseUrl}assets/creator/right.png`}
              alt=""
              className={styles.right}
              onClick={() => {
                previousAndNext(1);
              }}
            />
          </>
        )}
        <img
          src={`${
            current?.image_url ? current.image_url + "?x-oss-process=image/resize,w_600" : ""
          }`}
          alt={metaJson?.data?.promptInfo?.original}
          className={styles.preview}
        />
      </div>
      <ul className={styles.thumbnailList}>{thumbnailListNode}</ul>
      {![1, 2, 3, 4].includes(current?.status as number) && (
        <div style={{ display: "flex", marginTop: "12px" }}>
          <Album albumData={current} onAlbum={onAlbum} onError={onError} />
          <Divider orientation="vertical" mx="1em" h="32px" borderColor="#585858" />
          <GiveTheThumbsUp
            style={{
              width: 80,
              height: 32,
              textAlign: "center",
              background: "#424242",
              border: "1px solid #585858",
            }}
            image_id={current?.image_id as number}
            likes={current?.likes}
            is_like={current?.is_like}
            onLike={onLike}
            onCancelLike={onCancelLike}
            onError={onError}
          />
        </div>
      )}
    </div>
  );
};
export default observer(LeftContent);
